import { api } from './api';

export const fetchQualifications = (params) => {
  return api.get(`/qualification`, params);
};

export const fetchQualificationById = (id) => {
  return api.get(`/qualification/${id}`);
};

export const fetchQualificationActions = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => query.append(key, item));
    else return query.append(key, value);
  });
  return api.get('/qualification/actions', query);
};

export const fetchQualificationActionsTotals = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => query.append(key, item));
    else return query.append(key, value);
  });
  return api.get('/qualification/actions/totals', query);
};

export const fetchUpdateQualification = (id, slug, data) => {
  return api.post(`/qualification/${id}/requirement/${slug}`, data);
};
